import '../TeamsPage/index.scss';
import './index.scss';

import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';

import ErrorView from '@components/ErrorView';
import LoadingIndicator from '@components/LoadingIndicator';
import PageHeader from '@components/PageHeader';
import useVolunteerTeam from '@hooks/Volunteering/useVolunteerTeam';
import TeamsWorkspace from '../TeamsPage/TeamsWorkspace';

// What the teams overview hands over so the header reads correctly before the
// team's request comes back.
type RoutedTeam = {
  teamName?: string;
};

// One team with every volunteer on it. The teams overview only previews each
// team, so this is where the rest of a big team lives.
export default function VolunteerTeamPage() {
  const { teamID } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const routedTeam = (location.state as RoutedTeam | null) ?? null;

  const { bundle, loading, error, refetch } = useVolunteerTeam(teamID);

  if (!teamID) {
    return <Navigate to='/volunteering' replace />
  }

  if (!loading && !bundle) {
    return <ErrorView
      title='Unable to Load Team'
      error={error ?? 'This team may have been deleted.'}
      buttonText='Back to Teams'
      buttonAction={() => navigate('/volunteering')}
      fullHeight />
  }

  const teamName = bundle?.team.attributes.name || routedTeam?.teamName || '';

  return <div className='volunteering-people-page volunteer-team-page'>
    <PageHeader
      title={teamName}
      backLocation='/volunteering' />

    {loading && !bundle ? <LoadingIndicator /> : null}

    {bundle ? <TeamsWorkspace bundles={[bundle]} refetch={refetch} variant='team-page' /> : null}
  </div>
}
